
define('template!adminQrCodeGeneratorView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="qr-form">\n  <label class="qr-field">\n    <span class="qr-label">' +
((__t = ( _.escape(labels.text) )) == null ? '' : __t) +
'</span>\n    <textarea class="js-text" rows="4" placeholder="' +
((__t = ( _.escape(labels.textPlaceholder) )) == null ? '' : __t) +
'"></textarea>\n  </label>\n\n  <div class="qr-row">\n    <label class="qr-field">\n      <span class="qr-label">' +
((__t = ( _.escape(labels.size) )) == null ? '' : __t) +
'</span>\n      <span class="qr-size">\n        <input type="number" class="js-size" min="1" step="1" value="' +
((__t = ( size )) == null ? '' : __t) +
'"/>\n        <select class="js-unit">\n          <option value="px">px</option>\n          <option value="mm">mm</option>\n        </select>\n      </span>\n    </label>\n    <label class="qr-field">\n      <span class="qr-label">' +
((__t = ( _.escape(labels.level) )) == null ? '' : __t) +
'</span>\n      <select class="js-level">\n        ';
 _.each(levels, function (level) { ;
__p += '\n          <option value="' +
((__t = ( level.value )) == null ? '' : __t) +
'" ' +
((__t = ( level.value === 'M' ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.escape(level.label) )) == null ? '' : __t) +
'</option>\n        ';
 }); ;
__p += '\n      </select>\n    </label>\n    <label class="qr-field">\n      <span class="qr-label">' +
((__t = ( _.escape(labels.margin) )) == null ? '' : __t) +
'</span>\n      <input type="number" class="js-margin" min="0" max="20" step="1" value="4"/>\n    </label>\n  </div>\n  <div class="qr-hint js-hint"></div>\n\n  <div class="qr-actions">\n    <button type="button" class="qr-btn js-download" data-format="png" disabled><i class="fa fa-download"></i> PNG</button>\n    <button type="button" class="qr-btn js-download" data-format="svg" disabled><i class="fa fa-download"></i> SVG</button>\n    <button type="button" class="qr-btn js-download" data-format="pdf" disabled><i class="fa fa-download"></i> PDF</button>\n  </div>\n</div>\n\n<div class="qr-preview">\n  <div class="qr-preview-box js-preview">\n    <span class="qr-empty">' +
((__t = ( _.escape(labels.empty) )) == null ? '' : __t) +
'</span>\n  </div>\n</div>\n';

}
return __p
};});

